
<div class="view-component-body form-field-density-4">
    <div class="content">
            <div class="cardcontent">
                <div class="esquerda">
                    <div class="title-local">Variáveis</div>                        
                    <mat-selection-list #list class="customlist" [multiple]="false"  (selectionChange)="selectItem($event)">
                        <mat-list-option *ngFor="let variable of listvariable" [value]="variable">
                        {{variable.key}} - {{variable.value}}
                        </mat-list-option>
                    </mat-selection-list>
                    <mat-toolbar>
                        <mat-toolbar-row>
                            <div class="space button-density-4" >
                                <button mat-mini-fab color="primary" (click)="novo()" [disabled]="novoDisable"  matTooltip="Novo">
                                    <mat-icon>add</mat-icon>
                                </button>
                                <button mat-mini-fab color="warn" (click)="remove()" [disabled]="removeDisable" matTooltip="Remover">
                                    <mat-icon>remove</mat-icon>
                                </button>
                                <button mat-mini-fab color="success" (click)="salvar()"  [disabled]="salvarDisable"  matTooltip="Salvar">
                                    <mat-icon>check</mat-icon>
                                </button>
                                <button mat-mini-fab color="accent" (click)="cancel()" [disabled]="cancelDisable"  matTooltip="Limpar">
                                    <mat-icon >clear</mat-icon>
                                </button>
                                <button mat-mini-fab color="primary" (click)="duplicate()" [disabled]="!canDuplicate" matTooltip="Duplicar">
                                    <mat-icon >content_copy</mat-icon>
                                </button>
                                <div fxFlex></div>
                                <button mat-mini-fab color="primary" (click)="validate()" [disabled]="cancelDisable" matTooltip="Validar"  *ngIf="tipo=='XML'||tipo=='JSON'">
                                    <mat-icon >check_circle</mat-icon>
                                </button>
                                <button mat-mini-fab color="primary" (click)="export()" [disabled]="cancelDisable" matTooltip="Baixar Arquivo"  *ngIf="tipo=='XML'||tipo=='JSON'">
                                    <mat-icon >download</mat-icon>
                                </button>
                            </div>
                        </mat-toolbar-row>
                    </mat-toolbar>
                    <div *ngIf="editing" class="divcontent">
                        
                            <mat-form-field appearance="outline" class="no-padding-form-field" >
                                <mat-label>Chave</mat-label>
                                <input matInput type="text"required [formControl]="keyControl" >
                                <button *ngIf="keyControl.value" matSuffix mat-icon-button aria-label="Clear" (click)="limparValor(keyControl)">
                                <mat-icon>close</mat-icon>
                                </button>
                            </mat-form-field>
                            <mat-form-field appearance="outline" class="no-padding-form-field">
                                <mat-label>Tipo</mat-label>
                                <mat-select [(value)]="select"  required  [formControl]="tipoControl" >
                                <mat-option *ngFor="let tipo of tipos" [value]="tipo" >
                                    {{tipo}}
                                </mat-option>
                                </mat-select>
                            </mat-form-field>
                            <div class="fieldsize25">
                                <mat-form-field appearance="outline" class="customtextarea no-padding-form-field fill-container" >
                                    <mat-label>Valor</mat-label>
                                    <textarea  matInput type="text"  [formControl]="valorControl" required  ></textarea>
                                    <button *ngIf="valorControl.value" matSuffix mat-icon-button aria-label="Clear" (click)="limparValor(valorControl)">
                                    <mat-icon>close</mat-icon>
                                    </button>
                                </mat-form-field>
                            </div>
                        </div>
                </div>
                <mat-divider vertical="true"></mat-divider>
                <div class="direita">
                    <formula-tester-action [listvariable]="listvariable" [formula]="formula" [small]="small" (formulaChange)="changeFormula($event)" [ts]="ts"></formula-tester-action>
                </div>
            </div>
    </div>
    <div class="action-image-buttons" *ngIf="popup">
        <actions-buttons [buttonList]="buttonList" [data]="{formula}"></actions-buttons>
    </div>        
</div>
